module.exports = __webpack_public_path__ + "static/media/480.7e31c8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-interior/light/480.png
// module id = 2204
// module chunks = 2